import { Component } from '@angular/core';
import { DynamicConfigService } from '@cleverconnect/ngx-dynamic-config';

import { Config } from '../config/config';

@Component({
  selector: 'app-chabot',
  templateUrl: './chabot.component.html',
  styleUrls: ['./chabot.component.scss'],
})
export class ChabotComponent {
  constructor(private configService: DynamicConfigService) {}

  public redirectToHelp() {
    const url = this.configService.get<Config>().helpDeskUrl;
    window.open(url, '_blank');
  }
}
